import React from 'react'

export default function CustomCard(props: any) {
  return (
    <div className='card'>
      <div className='card-body px-lg-4 px-2'>{props.children}</div>
    </div>
  )
}
